'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _delay = require('lodash/delay');

var _delay2 = _interopRequireDefault(_delay);

var _includes = require('lodash/includes');

var _includes2 = _interopRequireDefault(_includes);

var _noop = require('lodash/noop');

var _noop2 = _interopRequireDefault(_noop);

var _uniq = require('lodash/uniq');

var _uniq2 = _interopRequireDefault(_uniq);

var _without = require('lodash/without');

var _without2 = _interopRequireDefault(_without);

var _OverlayTrigger = require('react-bootstrap/lib/OverlayTrigger');

var _OverlayTrigger2 = _interopRequireDefault(_OverlayTrigger);

var _Popover = require('react-bootstrap/lib/Popover');

var _Popover2 = _interopRequireDefault(_Popover);

var _popoverModule = require('./popover.module.less');

var _popoverModule2 = _interopRequireDefault(_popoverModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// Using a wrapper for the full width popover so we can control its positioning (Overlay does it otherwise)
var PopoverWrapper = function PopoverWrapper(props) {
  var popoverPadding = props.popoverPadding,
      popoverArrowOffsetLeft = props.popoverArrowOffsetLeft,
      children = props.children,
      otherProps = _objectWithoutProperties(props, ['popoverPadding', 'popoverArrowOffsetLeft', 'children']);

  return _react2.default.createElement(
    _Popover2.default,
    _extends({}, otherProps, {
      bsClass: _popoverModule2.default.popover,
      arrowOffsetLeft: popoverArrowOffsetLeft,
      style: {
        left: popoverPadding + 'px',
        right: popoverPadding + 'px'
      }
    }),
    children
  );
};

PopoverWrapper.displayName = 'nw-popover-wrapper';

PopoverWrapper.propTypes = {
  popoverArrowOffsetLeft: _propTypes2.default.number,
  popoverPadding: _propTypes2.default.number,
  children: _propTypes2.default.node
};

PopoverWrapper.defaultProps = {
  popoverPadding: 18,
  popoverArrowOffsetLeft: 0,
  children: null
};

var Popover = function (_Component) {
  _inherits(Popover, _Component);

  function Popover() {
    _classCallCheck(this, Popover);

    return _possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).apply(this, arguments));
  }

  _createClass(Popover, [{
    key: 'show',
    value: function show() {
      this.BSOverlayTrigger.show();
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.BSOverlayTrigger.hide();
    }
  }, {
    key: 'hoverContentMouseOver',
    value: function hoverContentMouseOver() {
      this.hide = _noop2.default;
      this.show();
    }
  }, {
    key: 'hoverContentMouseOut',
    value: function hoverContentMouseOut() {
      var _this2 = this;

      this.hide = this.BSOverlayTrigger.hide.bind(this.BSOverlayTrigger);
      (0, _delay2.default)(function () {
        _this2.hide();
      }, 300);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          container = _props.container,
          fullWidthProps = _props.fullWidthProps,
          id = _props.id,
          onClick = _props.onClick,
          placement = _props.placement,
          popoverClassName = _props.popoverClassName,
          popoverContent = _props.popoverContent,
          rootClose = _props.rootClose,
          shouldDelay = _props.shouldDelay,
          type = _props.type;

      // Extended "hoverContent" behavior:
      // Allow the popover content to be hoverable,
      // by adding a timeout to the mouseout,
      // and adding a mouseover/out to the content.

      var overlay = void 0;
      var onMouseOut = void 0;
      var onMouseOver = void 0;
      var trigger = type;

      if (typeof trigger === 'string') {
        trigger = [trigger];
      }

      trigger = (0, _without2.default)(trigger, 'manual');

      if ((0, _includes2.default)(trigger, 'hoverContent')) {
        trigger = (0, _without2.default)(trigger, 'hoverContent');
        trigger.push('hover');
        onMouseOver = this.hoverContentMouseOver.bind(this);
        onMouseOut = this.hoverContentMouseOut.bind(this);
      }

      trigger = (0, _uniq2.default)(trigger);

      var baseProps = {
        id: id,
        role: 'tooltip',
        // onMouseOver must be accompanied by onFocus for accessibility
        onMouseOver: onMouseOver,
        onFocus: onMouseOver,
        // onMouseOut must be accompanied by onBlur for accessibility
        onMouseOut: onMouseOut,
        onBlur: onMouseOut,
        bsClass: _popoverModule2.default.popover,
        className: (0, _classnames2.default)(popoverClassName, {
          'full-width': fullWidthProps
        })
      };

      if (fullWidthProps) {
        overlay = _react2.default.createElement(
          PopoverWrapper,
          _extends({}, baseProps, fullWidthProps),
          popoverContent
        );
      } else {
        overlay = _react2.default.createElement(
          _Popover2.default,
          baseProps,
          popoverContent
        );
      }

      return _react2.default.createElement(
        _OverlayTrigger2.default,
        {
          ref: function ref(BootStrapOverlayTrigger) {
            _this3.BSOverlayTrigger = BootStrapOverlayTrigger;
          },
          container: container,
          containerPadding: 10,
          delay: shouldDelay ? 1500 : null,
          onClick: onClick,
          overlay: overlay,
          placement: placement,
          rootClose: rootClose,
          trigger: trigger
        },
        _react2.default.createElement(
          'span',
          {
            'aria-describedby': id,
            className: (0, _classnames2.default)([className, _popoverModule2.default['popover-overlay-trigger']]),
            onMouseOver: onMouseOver,
            onMouseOut: onMouseOut,
            onFocus: onMouseOver,
            onBlur: onMouseOut
          },
          children
        )
      );
    }
  }]);

  return Popover;
}(_react.Component);

exports.default = Popover;


Popover.displayName = 'nw-popover';

Popover.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  /* Specify container to control the DOM element to which to append the overlay */
  container: _propTypes2.default.node,
  // eslint-disable-next-line react/forbid-prop-types
  fullWidthProps: _propTypes2.default.object,
  id: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
  popoverClassName: _propTypes2.default.string,
  popoverContent: _propTypes2.default.node,
  rootClose: _propTypes2.default.bool,
  /* A flag to indicate if a 3000ms delay should be set on the delayShow prop:
   * react-bootstrap.github.io/components/tooltips/#overlays-trigger-props
    * Generally used to give users more time to
   * hover over the AdvertiserDisclosure.
   */
  shouldDelay: _propTypes2.default.bool,
  type: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['manual', 'click', 'hover', 'focus', 'hoverContent']), _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['click', 'hover', 'focus', 'hoverContent']))])
};

Popover.defaultProps = {
  children: null,
  className: '',
  container: null,
  fullWidthProps: null,
  id: '',
  onClick: function onClick() {},
  placement: 'bottom',
  popoverClassName: '',
  popoverContent: null,
  rootClose: false,
  shouldDelay: false,
  type: ['hoverContent', 'click']
};
Popover.__docgenInfo = {
  'description': '',
  'displayName': 'nw-popover',
  'props': {
    'children': {
      'type': {
        'name': 'node'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'className': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      }
    },
    'container': {
      'type': {
        'name': 'node'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'fullWidthProps': {
      'type': {
        'name': 'object'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'id': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      }
    },
    'onClick': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '() => {}',
        'computed': false
      }
    },
    'placement': {
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'top\'',
          'computed': false
        }, {
          'value': '\'right\'',
          'computed': false
        }, {
          'value': '\'bottom\'',
          'computed': false
        }, {
          'value': '\'left\'',
          'computed': false
        }]
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'bottom\'',
        'computed': false
      }
    },
    'popoverClassName': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      }
    },
    'popoverContent': {
      'type': {
        'name': 'node'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'rootClose': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'false',
        'computed': false
      }
    },
    'shouldDelay': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'false',
        'computed': false
      }
    },
    'type': {
      'type': {
        'name': 'union',
        'value': [{
          'name': 'enum',
          'value': [{
            'value': '\'manual\'',
            'computed': false
          }, {
            'value': '\'click\'',
            'computed': false
          }, {
            'value': '\'hover\'',
            'computed': false
          }, {
            'value': '\'focus\'',
            'computed': false
          }, {
            'value': '\'hoverContent\'',
            'computed': false
          }]
        }, {
          'name': 'arrayOf',
          'value': {
            'name': 'enum',
            'value': [{
              'value': '\'click\'',
              'computed': false
            }, {
              'value': '\'hover\'',
              'computed': false
            }, {
              'value': '\'focus\'',
              'computed': false
            }, {
              'value': '\'hoverContent\'',
              'computed': false
            }]
          }
        }]
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '[\'hoverContent\', \'click\']',
        'computed': false
      }
    }
  }
};